<template>
	<b-form-input-limited :maxlength="300" placeholder="Paste a direct link to an image (.jpg, .jpeg, .png, .gif, .tiff) here" :disabled="validatingImage" :state="editImageURL == null ? (required ? false : null) : imageURLValid ? true : false" v-model="editImageURL"/>
</template>

<script>
import BFormInputLimited from '@/components/input_limited/BFormInputLimited.vue';
export default {
	components:
	{
		BFormInputLimited
	},
	props: {
		value: String,
		required: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			editImgSrc: "",
			editImgValid: false,
			validatingImage: false,
		}
	},
	watch: {
		'value'(cur, old)
		{
			this.editImageURL = cur;
		}
	},
	computed: {
		image: {
			get(){
				return this.value;
			},
			set(value){
				this.$emit('input', value);
			}
		},
		imageURLValid(){
			return this.editImgValid;
		},
		editImageURL: {
			get(){
				return this.editImgSrc;
			},
			set(value) {
				this.editImgValid = false;
				this.editImgSrc = value;
				if (value.trim() == '')
				{
					this.$emit('image-validated', this.image);
					this.image = '';
					this.editImgValid = true;
					return;
				}
				if (value.match(/[Hh][Tt][Tt][Pp]([Ss])?:\/\//))
				{
					if (value.toLowerCase().match(/((\.gif)|(\.jpg)|(\.jpeg)|(\.png)|(\.svg)|(\.tiff))$/))
					{
						let image = new Image();
						image.src = value;
						this.validatingImage = true;
						image.onload = ()=>{
							this.$emit('input', {target: this});
							this.editImgValid = true;
							this.image = value;
							this.validatingImage = false;
						}
						image.onerror = ()=>{
							this.validatingImage = false;
							this.$emit('image-invalidated', this.image);
						}
					}
				}
			}
		},
		loadedImage() {
			let img = new Image();
			img.src = this.rawImageUrl;
			if (!img.complete)
			{
				console.log("Image not cached");
				img.onload = ()=>{
					console.log('Image fully loaded');
					this.$recompute('isImageLoaded')
					this.$recompute('imageUrl')
				}
			}
			return img;
		},
		rawImageUrl() {
			return this.image;
		}
	},
	recomputed: {
		isImageLoaded() {
			return this.loadedImage.complete;
		},
		imageUrl() {
			let rawURL = this.rawImageUrl;
			return rawURL;
		},
	},
	mounted(){
		this.editImageURL = this.value;
	}
}
</script>

<style lang="scss" scoped>

</style>